import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import i18n from './i18n';
import Login from './containers/Login';
import SecureLogin from './containers/SecureLogin';
import ResetPassword from './containers/ResetPassword';
import Home from './containers/Home';
import Ajax from './containers/Ajax';
import Persons from './containers/Persons';
import DoorsAndLocations from './containers/DoorsAndLocations';
import AccessLevels from './containers/AccessLevels';
import DoorControls from './containers/DoorControls';
import Schedules from './containers/Schedules';
import TagTypes from './containers/TagTypes';
import EventReports from './containers/EventReports';
import Monitoring from './containers/Monitoring';
import AuditLogs from './containers/AuditLogs';
import Controllers from './containers/Controllers';
import Users from './containers/Users';
import Customers from './containers/Customers';

// if a route is behind auth, use this wrapper to define route
function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authed ? <Component {...props} /> : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      }
    />
  );
}

export const navItems = [
  {
    name: i18n.t('navigation.home'),
    route: '/',
    icon: 'Home',
    isFirst: true,
    showToReceptionUser: true,
  },
  {
    name: i18n.t('navigation.ajax'),
    route: '/ajax',
    icon: 'Ajax',
    isInDashboardsMenu: true,
    isPng: true,
  },
  {
    name: i18n.t('navigation.persons'),
    route: '/persons',
    icon: 'Persons',
    showToReceptionUser: true,
  },
  {
    name: i18n.t('navigation.doorsAndLocations'),
    route: '/doors-and-locations',
    icon: 'DoorsAndLocations',
  },
  {
    name: i18n.t('navigation.accessLevels'),
    route: '/access-levels',
    icon: 'AccessLevels',
  },
  {
    name: i18n.t('navigation.doorControls'),
    route: '/door-controls',
    icon: 'DoorControls',
  },
  {
    name: i18n.t('navigation.schedules'),
    route: '/schedules',
    icon: 'Schedules',
  },
  {
    name: i18n.t('navigation.tagTypes'),
    route: '/tag-types',
    icon: 'TagTypes',
  },
  {
    name: i18n.t('ReportManager_getEventReport_navigation_title'),
    route: '/event-reports',
    icon: 'Reports',
    isInReportsMenu: true,
    showToReceptionUser: true,
  },
  {
    name: i18n.t('navigation.auditLogs'),
    route: '/audit-logs',
    icon: 'AuditLogs',
    isPng: true,
    isInReportsMenu: true,
    hideToTicketingAdmin: true,
  },
  {
    name: i18n.t('navigation.monitoring'),
    route: '/monitoring',
    icon: 'Monitoring',
    isPng: true,
    isInReportsMenu: true,
    showToReceptionUser: true,
  },
  {
    name: i18n.t('framesIndex_widget_controllers'),
    route: '/controllers',
    icon: 'Users',
    isInAdminMenu: true,
  },
  {
    name: i18n.t('framesIndex_widget_users'),
    route: '/users',
    icon: 'Users',
    isInAdminMenu: true,
  },
  {
    name: i18n.t('framesIndex_widget_customers'),
    route: '/customers',
    icon: 'Customers',
    isInDistributorAdminMenu: true,
  },
];

const Routes = (props) => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/secure-login" component={SecureLogin} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <PrivateRoute authed={props.authed} exact path="/" component={Home} />
    <PrivateRoute authed={props.authed} exact path="/ajax" component={Ajax} />
    <PrivateRoute authed={props.authed} exact path="/persons" component={Persons} />
    <PrivateRoute authed={props.authed} exact path="/doors-and-locations" component={DoorsAndLocations} />
    <PrivateRoute authed={props.authed} exact path="/access-levels" component={AccessLevels} />
    <PrivateRoute authed={props.authed} exact path="/door-controls" component={DoorControls} />
    <PrivateRoute authed={props.authed} exact path="/schedules" component={Schedules} />
    <PrivateRoute authed={props.authed} exact path="/tag-types" component={TagTypes} />
    <PrivateRoute authed={props.authed} exact path="/event-reports" component={EventReports} />
    <PrivateRoute authed={props.authed} exact path="/audit-logs" component={AuditLogs} />
    <PrivateRoute authed={props.authed} exact path="/monitoring" component={Monitoring} />
    <PrivateRoute authed={props.authed} exact path="/controllers" component={Controllers} />
    <PrivateRoute authed={props.authed} exact path="/users" component={Users} />
    <PrivateRoute authed={props.authed} exact path="/customers" component={Customers} />
    <PrivateRoute authed={props.authed} component={Home} />
  </Switch>
);

export default Routes;
